import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { Offline } from 'react-detect-offline';

import Menu from './components/Menu';
import Home from './screens/Home';
import Package from './screens/Package';
import Videos from './screens/Videos';
import Photos from './screens/Photos';
import About from './screens/About';
import Contact from './screens/Contact';
import Testimonials from './screens/Testimonials';
import PackageArtistas from './screens/PackageArtistas';
import PackageServices from './screens/PackageServices';
import PackageResume from './screens/PackageResume';
import VideosProm from './screens/VideosProm';
import Estimate from './screens/Estimate';

class Routes extends Component {

  componentWillMount(){}

  render() {
    return (
      <div>
        <Offline>
          <div style={{ color: '#FFF' }}>
            Usted está navegando sin internet
          </div>
        </Offline>
        <Switch>
          <Route exact path="/home" component={Home} />
          <Route exact path="/package" component={Package} />
          <Route exact path="/videos" component={Videos} />
          <Route exact path="/photos" component={Photos} />
          <Route exact path="/about" component={About} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/testimonials" component={Testimonials} />
          <Route exact path="/package_artistas" component={PackageArtistas} />
          <Route exact path="/package_services" component={PackageServices} />
          <Route exact path="/package_resume" component={PackageResume} />
          <Route exact path="/videos_proms" component={VideosProm} />
          <Route exact path="/estimate" component={Estimate} />
          <Redirect from="/" to="home" />
        </Switch>
        <Menu />
      </div>
    );
  }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/Routes.js